export interface IReportTransfers {
  items: IReportTransferItem[];
}

export interface IReportTransferItem {
  orderId: string;
  supplyingLocationName: string;
  supplyingLocationId: string;
  createdBy: string;
  createdById: string;
  createdAt: string;
  receivingLocationName: string;
  receivingLocationId: string;
  product: IReportTransferProduct;
  status: IReportTransferStatus;
  receivedBy: string;
  receivedById: string;
  receivedAt: string;
  vehicleName: string;
  vehicleId: string;
  driverName: string;
  driverId: string;
  contactNumber: string;
  comment: string;
}

interface IReportTransferProduct {
  id: string;
  name: string;
  sku: string;
  quantity: number;
  value: number;
}

interface IReportTransferStatus {
  orderEventId: string;
  orderEventType: string;
  userId: string;
  username: string;
}
